import type { Card } from "@memento/types/card";
import type { Body as UpdateCardGranularBody } from "@memento/app/endpoints/card/update-granular";
import { Fetcher } from "src/libs/fetcher";
import { getCardEndpointUrl } from "src/libs/api-endpoint-lib";
import { GetAccessTokenFn } from "src/contexts/AuthProvider";
import { addUrlParams } from "src/libs/urlLib";

type GetCardArgs = {
  cardUrl?: string;
  cardId?: string;
  referrer?: string;
  /** Tell the API to register a page view on this request. */
  shouldCountView?: boolean;
};

export const getCard = async ({
  cardUrl,
  cardId,
  referrer,
  shouldCountView,
}: GetCardArgs) => {
  if (!cardUrl || !cardId) {
    return null;
  }

  try {
    // Only pass the `/record` referrer for fetches from that
    // page for purposes of counting record page views
    return Fetcher()(
      addUrlParams(getCardEndpointUrl(cardUrl, cardId), {
        ...(shouldCountView && { cv: 1 }),
      }),
      {
        headers: referrer
          ? {
              Referer: referrer,
            }
          : undefined,
      }
    );
  } catch (err) {
    console.log(err);
    return null;
  }
};

export async function updateCardGranular(
  getAccessToken: GetAccessTokenFn,
  cardUrl: string,
  cardId: string,
  card: UpdateCardGranularBody
): Promise<Card> {
  const fetcher = Fetcher(getAccessToken);

  return fetcher(`/cards/${cardUrl}/${cardId}/granular`, {
    method: "PUT",
    body: card,
  });
}
